class EmilyPopupElement extends HTMLElement {
  connectedCallback() {
    if (sessionStorage.getItem('emilyPopupShown') === '1') return;
    const delay = Number(this.dataset.delay || 15) * 1000;
    const useExit = this.dataset.exit === 'true';
    const show = () => {
      if (sessionStorage.getItem('emilyPopupShown') === '1') return;
      sessionStorage.setItem('emilyPopupShown', '1');
      this.hidden = false;
      requestAnimationFrame(() => this.classList.add('is-open'));
      this.querySelector('input[type="email"]')?.focus();
    };
    const timer = setTimeout(show, delay);
    const onExit = (event) => {
      if (event.clientY <= 0) { clearTimeout(timer); show(); document.removeEventListener('mouseout', onExit); }
    };
    if (useExit) document.addEventListener('mouseout', onExit);
    this.querySelectorAll('[data-close]').forEach((el) => {
      el.addEventListener('click', () => {
        this.classList.remove('is-open');
        setTimeout(() => { this.hidden = true; }, 250);
      });
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !this.hidden) this.querySelector('[data-close]')?.click();
    });
    this.addEventListener('submit', () => {
      this.classList.remove('is-open');
      setTimeout(() => { this.hidden = true; }, 250);
    });
  }
}
if (!customElements.get('emily-popup')) customElements.define('emily-popup', EmilyPopupElement);
